import { useState } from "react";
import { Box, Input, SimpleGrid, Text } from "@chakra-ui/react";
import { FilterChip } from "../../FilterChip";

export function StepDuration({ durations, answers, setAnswers }) {
  const multiDayOption = durations.find((d) => d.requires_duration_days);
  const singleOptions = durations.filter((d) => !d.requires_duration_days);

  // Tracked separately from answers.duration_days because "2 dias de festa"
  // and "Mais dias de festa" can resolve to the same duration_days value
  // (e.g. when min_duration_days === default_duration_days) — the raw value
  // alone can't tell the two chips apart.
  const [multiDayMode, setMultiDayMode] = useState(() => {
    if (!multiDayOption || answers.duration !== multiDayOption.key) return null;
    return answers.duration_days === multiDayOption.default_duration_days ? "default" : "custom";
  });

  function selectSingle(key) {
    setMultiDayMode(null);
    setAnswers((prev) => ({ ...prev, duration: key, duration_days: null }));
  }

  function selectDefaultMultiDay() {
    if (!multiDayOption) return;
    setMultiDayMode("default");
    setAnswers((prev) => ({
      ...prev,
      duration: multiDayOption.key,
      duration_days: multiDayOption.default_duration_days,
    }));
  }

  function selectCustomMultiDay() {
    if (!multiDayOption) return;
    setMultiDayMode("custom");
    setAnswers((prev) => ({
      ...prev,
      duration: multiDayOption.key,
      duration_days:
        prev.duration_days && prev.duration_days >= multiDayOption.min_duration_days
          ? prev.duration_days
          : multiDayOption.min_duration_days,
    }));
  }

  function handleCustomDaysChange(e) {
    const raw = e.target.value.replace(/\D/g, "");
    const value = raw ? parseInt(raw, 10) : null;
    setAnswers((prev) => ({ ...prev, duration: multiDayOption.key, duration_days: value }));
  }

  return (
    <Box>
      <Text fontSize={{ base: "17px", md: "20px" }} fontWeight="900" color="#004a33" mb="3px">
        Quanto tempo vai durar o evento?
      </Text>
      <Text fontSize="12px" color="gray.500" mb="12px">
        A duração muda quanto cada pessoa costuma consumir.
      </Text>

      <SimpleGrid columns={{ base: 1, sm: 3 }} spacing="6px" mb={multiDayOption ? "10px" : "0"}>
        {singleOptions.map((d) => (
          <FilterChip
            key={d.key}
            label={d.label}
            isActive={answers.duration === d.key}
            onClick={() => selectSingle(d.key)}
          />
        ))}
      </SimpleGrid>

      {multiDayOption && (
        <Box>
          <SimpleGrid columns={{ base: 1, sm: 2 }} spacing="6px" mb={multiDayMode === "custom" ? "8px" : "0"}>
            <FilterChip
              label={`${multiDayOption.default_duration_days} dias de festa`}
              isActive={multiDayMode === "default"}
              onClick={selectDefaultMultiDay}
            />
            <FilterChip
              label="Mais dias de festa"
              isActive={multiDayMode === "custom"}
              onClick={selectCustomMultiDay}
            />
          </SimpleGrid>

          {multiDayMode === "custom" && (
            <Box maxW="160px">
              <Text fontSize="11px" fontWeight="700" color="#004a33" mb="4px">
                Quantos dias?
              </Text>
              <Input
                type="text"
                inputMode="numeric"
                placeholder={`Mín. ${multiDayOption.min_duration_days}`}
                value={answers.duration_days ?? ""}
                onChange={handleCustomDaysChange}
                bg="white"
                border="1.5px solid rgba(0,74,51,0.2)"
                borderRadius="10px"
                h="36px"
                fontSize="13px"
                fontWeight="700"
                color="#004a33"
                _focus={{ borderColor: "#004a33", boxShadow: "none" }}
              />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
